import React from 'react'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import axios from 'axios';
import {renderField} from '../../util/inputs';
import cadastrarAgencia from '../../actions/agencia/cadastrarAgencia';

import alterarAgencia from '../../actions/agencia/alterarAgencia';
import selecionarAgencia from '../../actions/agencia/selecionarAgencia';
import {URL} from '../../util/ambienteActions';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalCadastrarCidade extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.state = { mensagem: null }
  }

  // eslint-disable-next-line
  pesquisarPorCep (event) {
    const CEP = event.target.value.replace(/\D/g, '')
    if (CEP.length === 8) {
      const url = `${URL}/cep/public/${CEP}`
      axios.get(url, SLOW_REQUEST_CONFIG).then((resp) => {
        if (resp.status === 200) {
          this.props.changeFieldValue('formularioCadastrarCidade',
            'logradouro', resp.data.logradouro);
          this.props.changeFieldValue('formularioCadastrarCidade',
            'complemento', resp.data.complemento);
          this.props.changeFieldValue('formularioCadastrarCidade',
            'bairro', resp.data.bairro);
          this.props.changeFieldValue('formularioCadastrarCidade',
            'localidade', resp.data.localidade);
          this.props.changeFieldValue('formularioCadastrarCidade',
            'uf', resp.data.uf);
        }
      })
    }
  }

  limparCampos () {
    this.props.changeFieldValue('formularioCadastrarCidade',
      'nome', '');
    this.props.changeFieldValue('formularioCadastrarCidade',
      'logradouro', '');
    this.props.changeFieldValue('formularioCadastrarCidade',
      'complemento', '');
    this.props.changeFieldValue('formularioCadastrarCidade',
      'bairro', '');
    this.props.changeFieldValue('formularioCadastrarCidade',
      'localidade', '');
    this.props.changeFieldValue('formularioCadastrarCidade',
      'uf', '');
  }

  submit (values) {
    const agencia = {
      nome: values.nome,
      cep: values.cep,
      logradouro: values.logradouro,
      complemento: values.complemento,
      bairro: values.bairro,
      localidade: values.localidade,
      uf: values.uf,
      id: values.idAgencia,
      numero: values.numero,
      idEmpresa: this.props.empresaSelecionada.id
    };
    if (this.props.agenciaSelecionada && this.props.agenciaSelecionada.id) {
      this.alterar(agencia)
    } else {
      this.cadastrar(agencia);
    }
  }

  cadastrar (agencia) {
    this.props.cadastrarAgencia(agencia)
      .then(() => {
        showSuccessMsg('Agência cadastrada com sucesso');
        this.fecharModal();
        this.props.buscarAgencias();
      })
  }

  alterar (agencia) {
    this.props.alterarAgencia(agencia)
      .then(() => {
        showSuccessMsg('Agência alterada com sucesso');
        this.fecharModal();
        this.props.buscarAgencias();
      })
  }


  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  recuperaMensagem () {
    if (this.state.mensagem !== null && this.state.mensagem !== undefined) {
      if (this.state.mensagem.tipo === 'sucesso') {
        return (
          <div className="alert alert-success col-md-12">
            {this.state.mensagem.texto}
            <button type="button" className="close" aria-label="Close"
                    onClick={() => {
                      this.limparMensagem();
                      this.setState({ usuario: null })
                    }
                    }>
              <i className="material-icons">
                &#xe5cd;
              </i>
            </button>
          </div>
        )
      }
      if (this.state.mensagem.tipo === 'erro') {
        return (
          <div className="alert alert-danger col-md-12">
            {this.state.mensagem.texto}
            <button type="button" className="close" aria-label="Close"
                    onClick={() => {
                      this.limparMensagem();
                    }
                    }>
              <i className="material-icons">
                &#xe5cd;
              </i>
            </button>
          </div>
        )
      }
    }
    return ''
  }

  limparFormulario () {
    this.props.reset('formularioCadastrarAgencia');
    this.props.selecionarAgencia();
  }

  fecharModal () {
    $('#modalCadastrarAgencia')
      .modal('hide');
    $('#modalCadastrarAgencia')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.limparFormulario();
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;

    return (
      <div className="modal fade show" id='modalCadastrarAgencia' role='dialog'
           aria-labelledby='modalCadastrarAgencia' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-md'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>{this.props.agenciaSelecionada && this.props.agenciaSelecionada.id ? 'Alterar Agência' : 'Cadastrar Agência'}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={this.limparFormulario}>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              {this.recuperaMensagem()}
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                  <div className="col-12 col-sm-9 col-md-9">
                    <Field name="nome" type="text" component={renderField} label="Nome:"
                           css="form-control" readOnly={false}/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-4 col-md-4">
                    <Field name="cep" type="text" component={renderField} label="CEP:"
                           css="form-control" readOnly={false} onChange={e => this.pesquisarPorCep(e)}/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-9 col-md-9">
                    <Field name="logradouro" type="text" component={renderField} label="Logradouro:"
                           css="form-control" readOnly={false}/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-9 col-md-9">
                    <Field name="complemento" type="text" component={renderField} label="Complemento:"
                           css="form-control" readOnly={false}/>
                  </div>
                  <div className="col-12 col-sm-9 col-md-3">
                    <Field name="numero" type="text" component={renderField} label="Número:"
                           css="form-control" readOnly={false}/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-6 col-md-6">
                    <Field name="bairro" type="text" component={renderField} label="Bairro:"
                           css="form-control" readOnly={false}/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-6 col-md-6">
                    <Field name="localidade" type="text" component={renderField} label="Localidade:"
                           css="form-control" readOnly={false}/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-4 col-md-4">
                    <Field name="uf" type="text" component={renderField} label="UF:"
                           css="form-control" readOnly={false}/>
                  </div>
                </div>
                <Field name="idAgencia" type="hidden" component={renderField} css="form-control col-md-12"/>
                <div className="modal-footer mt-2">
                  <button type="submit" disabled={invalid || submitting || pristine}
                          className="btn btn-laranja">Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    agenciaSelecionada: state.agencias.agenciaSelecionada,
    empresaSelecionada: state.empresaSelecionada
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarAgencia,
    alterarAgencia,
    selecionarAgencia
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastrarCidade',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ModalCadastrarCidade));
